import isBrowser from './isBrowser';

export default function isBrowserFirefox(): boolean {
    return isBrowser() && navigator.userAgent.toLowerCase().includes('firefox');
}
